import { TaskCollectionTravelMode } from '../../enums/task-collection-travel-mode.enum';
import { IVehicle, IVehicleAddress } from '../../interfaces/task-info';
import { IOrgStepChecklistSubCategories } from '../../interfaces/organisation-specific-steps';
import {
  ICarryoverAddress,
  TravelSchedulerDTO,
} from '../../interfaces/travel-scheduler/travel-scheduler-task';
import { DriverScheduleUpdateTypeEnum } from '../../enums/driver-schedule-update-type-enum';

export interface ConfirmAllocationRequest {
  updateTaskScheduleDTOs: UpdateTaskScheduleDTO[];
  priceChangeReason: PriceChangeReason;
}

export interface PriceChangeReason {
  id: number;
  otherReason: string | null;
}

export class UpdateTaskScheduleDTO {
  taskId: number = null;
  specifiedPickUpTime: Date = new Date();
  specifiedDropOffTime: Date = new Date();
  taskCollectionTravelMode: TaskCollectionTravelMode = TaskCollectionTravelMode.Driving;
  noneSameDayDeliveryReasonId: number = null;
  updateDefaultTravelMode?: boolean = false;
  carryoverAddress: ICarryoverAddress = null;

  constructor(ts?: {
    noneSameDayDeliveryReasonId: null;
    taskId: number;
    specifiedPickUpTime: string;
    specifiedDropOffTime: string;
    taskCollectionTravelMode: TaskCollectionTravelMode;
    carryoverAddress: ICarryoverAddress;
  }) {
    if (ts) {
      this.specifiedDropOffTime = new Date(ts.specifiedDropOffTime);
      this.taskCollectionTravelMode = ts.taskCollectionTravelMode;
      this.taskId = ts.taskId;
      this.specifiedPickUpTime = new Date(ts.specifiedPickUpTime);
      this.noneSameDayDeliveryReasonId = ts.noneSameDayDeliveryReasonId;
      this.carryoverAddress = ts.carryoverAddress;
    }
  }
}

export interface TaskScheduleDTO {
  taskId: number;
  specifiedPickUpTime: string;
  specifiedDropOffTime: string;
  specifiedPickUpLatestTime?: string;
  specifiedDropOffLatestTime?: string;
  taskCollectionTravelMode: TaskCollectionTravelMode;
  noneSameDayDeliveryReasonId: number;
  defaultTaskCollectionTravelMode?: TaskCollectionTravelMode;
  lastUpdated?: Date;
  lastUpdatedByType?: DriverScheduleUpdateTypeEnum;
  carryoverAddress: ICarryoverAddress;
}

export interface JobTaskSupplierScheduleContextTask {
  id: number;
  currentSchedule: TaskScheduleDTO;
  pickupLocation: IVehicleAddress;
  dropoffLocation: IVehicleAddress;
  jobId: number;
  pickupEarliestDateTime: string;
  pickupLatestDateTime: string;
  dropoffEarliestDateTime: string;
  dropoffLatestDateTime: string;
  estimateTime: string;
  taskTypeName: string;
  vehicle: IVehicle;
  checklistSubCategories: IOrgStepChecklistSubCategories[];
}

export interface JobSupplierScheduleContext {
  jobId: number;
  jobNumber: string;
  grabDisabled: boolean;
  supplierId: number;
  tasks: JobTaskSupplierScheduleContextTask[];
}
